
import './assets/MediaQueries.css'
import React from 'react';
import Main from './Main.jsx';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

const App = () => {
 return (
      <div className="App">
        <Main />
        <ToastContainer position="bottom-center" autoClose={3000} hideProgressBar />
      </div>
  );
}
export default App;
